<div class="container">
    <div class="respondent-container" *ngIf="respondent">
        <h2>Respondent Information</h2>
        <label>
            Country:
            <input [(ngModel)]="respondent.country" />
        </label>
        <label>
            Country Code:
            <input [(ngModel)]="respondent.country_code" />
        </label>
        <label>
            Latitude:
            <input [(ngModel)]="respondent.latitude" />
        </label>
        <label>
            Longitude:
            <input [(ngModel)]="respondent.longitude" />
        </label>
        <label>
            Respondent Risk:
            <input [(ngModel)]="respondent.respondent_risk" />
        </label>
        <label>
            Respondent UD:
            <input [(ngModel)]="respondent.respondent_ud" />
        </label>
        <label>
            Threat Potential:
            <input [(ngModel)]="respondent.threat_potential" />
        </label>
        <label>
            Threat Potential Score:
            <input [(ngModel)]="respondent.threat_potential_score" />
        </label>
        <label>
            Weather Code:
            <input [(ngModel)]="respondent.weather_code" />
        </label>
        <label>
            Time Zone:
            <input [(ngModel)]="respondent.time_zone" />
        </label>
        <label>
            Usage Type:
            <input [(ngModel)]="respondent.usage_type" />
        </label>
    </div>

    <div class="surveys-container" *ngIf="surveys.length > 0">
        <h2>Surveys</h2>
        <div *ngFor="let survey of surveys">
            <label>
                Survey Number:
                <input [(ngModel)]="survey.survey_number" />
            </label>
            <label>
                Survey UD:
                <input [(ngModel)]="survey.sn_ud" />
            </label>
            <label>
                Flag:
                <input [(ngModel)]="survey.flag" />
            </label>
            <label>
                Duplicate Potential:
                <input [(ngModel)]="survey.duplicate_potential" />
            </label>
            <label>
                Duplicate Score:
                <input [(ngModel)]="survey.duplicate_score" />
            </label>
            <label>
                Country Mismatch:
                <input [(ngModel)]="survey.country_mismatch" />
            </label>
            <label>
                Duplicate Initial UD:
                <input [(ngModel)]="survey.duplicate_initial_ud" />
            </label>
            <label>
                Failure Reason:
                <input [(ngModel)]="survey.failure_reason" />
            </label>
            <label>
                Date:
                <input [(ngModel)]="survey.d_date" />
            </label>
        </div>
    </div>
</div>

<footer>
    <p class="copyright">Copyright © Research Defender . All Rights Reserved.</p>
</footer>